import { combineReducers } from 'redux'
import selectedAssessments from './selectedAssessments';
import surveyReducers from './surveyReducers';

export default combineReducers({
    selectedAssessments:selectedAssessments,
    survey:surveyReducers
})